import { render, staticRenderFns } from "./ExpenseIndex.vue?vue&type=template&id=b57d257a"
import script from "./ExpenseIndex.vue?vue&type=script&lang=js"
export * from "./ExpenseIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports